import { render, staticRenderFns } from "./SingleTable.vue?vue&type=template&id=5254911e&scoped=true"
import script from "./SingleTable.vue?vue&type=script&lang=js"
export * from "./SingleTable.vue?vue&type=script&lang=js"
import style0 from "./SingleTable.vue?vue&type=style&index=0&id=5254911e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5254911e",
  null
  
)

export default component.exports